import {useContext} from 'react'

import Helmet from 'react-helmet'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import {  LanguageContext } from '../context';
import AccessibilityHe from '../StaticPages/Accessibilty/AccessibilityHe';
import AccessibiltyEn from '../StaticPages/Accessibilty/AccessibiltyEn';
import MetaTags from '../Components/MetaTags/MetaTags';


const AccessibilityPage = () => {
    const { language } = useContext(LanguageContext);
    return (
      <div>

        <MetaTags title={"Accessibility page"} description={"Accessibility page information"}/>

        
        <Header/>
        <div role="main" aria-label="Accessibility">
        {
          language=="he"?<AccessibilityHe/>: <AccessibiltyEn/>
      }
       
      
        </div>
      
     
          <Footer/>
  
      </div>
    )
}

export default AccessibilityPage